// Pure classification for river-edge ship crossings.
//
// Sim `river_going` kinds (trade_ship / transport_ship) can only move
// land→land across river edges — deep-water ships stay at sea. So an
// adjacent-tile hop by one of these kinds is always an edge crossing, and
// the sprite should ride the drawn channel (centre → edge midpoint → centre,
// which is the straight line between adjacent hex centres) instead of
// snapping to the destination tile.

/** Adjacent hex centres are √3 apart (HEX_SIZE 1); the band tolerates
 * fractional transforms and rejects multi-tile hops (no per-step path data —
 * those keep the plain snap). */
const CROSSING_MIN_DIST = 1.2;
const CROSSING_MAX_DIST = 2.4;

const RIVER_GOING_KINDS: ReadonlySet<string> = new Set(['trade_ship', 'transport_ship']);

/** Should this world-space position change animate as a river-edge crossing? */
export function isRiverEdgeCrossing(kind: string, dx: number, dz: number): boolean {
  if (!RIVER_GOING_KINDS.has(kind)) return false;
  const dist = Math.hypot(dx, dz);
  return dist > CROSSING_MIN_DIST && dist < CROSSING_MAX_DIST;
}

/** Heading (rotation.y) along the travel direction for a crossing sprite. */
export function crossingYaw(dx: number, dz: number): number {
  return Math.atan2(dx, dz);
}
